import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import React, { useEffect, useState } from 'react'

const StatusFilter = ({
  cardNumber,
  setStatusList,
  value,
  filterData,
  cardsDetails,
}) => {
  const cardNumberNumeric = Number(cardNumber)
  const isSelected = cardsDetails?.some(card => card?.isSelected)
  const [tapNumber, setTapNumber] = useState(null)
  useEffect(() => {
    if (cardNumber != tapNumber) {
      setTapNumber(cardNumber)
      setStatusList('')
    }
    if (filterData !== false) {
      setStatusList('')
    }
  }, [cardNumber, filterData])

  const options = [
    {
      label: 'Active',
      value: '2',
      disabled:
        isSelected &&
        (cardNumberNumeric === 4 ||
          cardNumberNumeric === 6 ||
          cardNumberNumeric === 7),
    },
    {
      label: 'Pending',
      value: '1',
      disabled:
        isSelected &&
        (cardNumberNumeric === 1 ||
          cardNumberNumeric === 4 ||
          cardNumberNumeric === 6 ||
          cardNumberNumeric === 7),
    },
    {
      label: 'Invite Sent',
      value: '0',
      disabled:
        isSelected &&
        (cardNumberNumeric === 1 ||
          cardNumberNumeric === 4 ||
          cardNumberNumeric === 6 ||
          cardNumberNumeric === 7),
    },
    {
      label: 'Not Interested',
      value: '-3',
      disabled:
        isSelected &&
        (cardNumberNumeric === 1 ||
          cardNumberNumeric === 6 ||
          cardNumberNumeric === 7),
    },
  ]

  const onChange = checkedValues => {
    setStatusList(checkedValues)
  }

  return (
    <FilterCheckBoxComp options={options} value={value} onChange={onChange} />
  )
}

export default StatusFilter
